import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import Button from "../../../../components/Button";
import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/solid";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
import useAddRegion from "./hooks/useAddRegion";
import useUpdateRegion from "./hooks/useUpdateRegion";
import useRegion from "./hooks/useRegion";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import useGetAreaOptions from "./hooks/useGetAreaOptions";
import SelectInput from "../../../../components/SelectInput";
import CustomLoader from "../../../../components/CustomLoader";
import {
  addStateRegion,
  editStateRegion,
  setFilterTextRegion,
  setCheckStatusStateRegion,
  rowForEditStateRegion,
  disableButtonStateRegion,
  selectedRowsStateRegion,
  rowEditIdStateRegion,
  setLinkStateRegion,
  setButtonLinkTextStateRegion,
  setHierarchyIdStateRegion,
  setDescriptionRegionState,
} from "../../OfficeHierarchy/Region/atoms/atoms";
import { hierarchyTypeState } from "./../atoms/atoms";
import { useHistory } from "react-router-dom";
import { getHierarchyType } from "./../atoms/atoms";

import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS, FIELDPERMISSIONS } from "../../../PermissionsConstants";

const RegionForm = ({ employeeList }) => {
  //Hooks
  const AddRegion = useAddRegion();
  const UpdateRegion = useUpdateRegion();
  const data = useRegion();
  const history = useHistory();
  const [description] = useRecoilState(setDescriptionRegionState);
  const [type, setType] = useRecoilState(getHierarchyType);

  //Field Permission
  const contactPermission =
    FIELDPERMISSIONS.fieldpermission_officehierarchy_contact;
  const userPermissions = useRecoilValue(permissionsSelector);

  //Recoils Call
  const [actionAddState, setActionAddState] = useRecoilState(addStateRegion);
  const [actionEditState, setActionEditState] = useRecoilState(editStateRegion);
  const [, setFilterText] = useRecoilState(setFilterTextRegion);
  const [rowForEdit] = useRecoilState(rowForEditStateRegion);
  const [, setSelectedRows] = useRecoilState(selectedRowsStateRegion);
  const [, setEditRowId] = useRecoilState(rowEditIdStateRegion);
  const [checkStatus, setCheckStatus] = useRecoilState(
    setCheckStatusStateRegion
  );
  const [, setDisabledButton] = useRecoilState(disableButtonStateRegion);
  const userAccount = useRecoilValue(accountAtom);
  const [buttonLinkState, setButtonLinkState] =
    useRecoilState(setLinkStateRegion);
  const [buttonTextLinkState, setButtonTextLinkState] = useRecoilState(
    setButtonLinkTextStateRegion
  );
  const [hierarchyType, setHierarchyType] = useRecoilState(hierarchyTypeState);
  const [hierarcyId] = useRecoilState(setHierarchyIdStateRegion);
  //Local States
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasRegion, setHasRegion] = useState(false);
  const [regionExist, setRegionExist] = useState(false);
  const [, setEmpTypeIsExistState] = useState(false);
  const [openModalEdit, setOpenModalEdit] = useState(false);
  const [openAreaModal, setOpenAreaModal] = useState(false);
  const areaOptions = useGetAreaOptions()
    ?.filter((x) => x.isActive)
    .map((x) => {
      return { label: x.areaCode + " - " + x.areaName, value: x.areaId };
    });
  const defaultArea = useGetAreaOptions()
    ?.filter((x) => x.areaId === rowForEdit.areaId)
    .map((x) => {
      return { label: x.areaCode + " - " + x.areaName, value: x.areaId };
    });

  const employeeOptions = employeeList
    ?.filter((x) => x.status !== "Terminated")
    .map((x) => {
      return {
        label: x.employeenumber + " - " + x.fullname,
        value: x.employeenumber,
        email: x.email,
        empNo: x.employeenumber,
        fullname: x.fullname,
      };
    });
  const defaultEmployee = employeeList
    ?.filter((x) => x.fullname === rowForEdit.regionManager)
    .map((x) => {
      return {
        label: x.employeenumber + " - " + x.fullname,
        value: x.employeenumber,
        email: x.email,
        empNo: x.employeenumber,
        fullname: x.fullname,
      };
    });

  const defaulValues = {
    regionId: 0,
    regionCode: "",
    regionName: "",
    regionManager: "",
    managerEmail: "",
    managerUltiproNumber: "",
    areaId: 0,
    createdBy: "",
    createdOn: null,
    updatedBy: "",
    updatedOn: null,
    isActive: 0,
  };
  const defaultEditValues = {
    regionId: rowForEdit.regionId,
    regionCode: rowForEdit.regionCode,
    regionName: rowForEdit.regionName,
    regionManager: rowForEdit.regionManager,
    managerEmail: rowForEdit.managerEmail,
    managerUltiproNumber: rowForEdit.managerUltiproNumber,
    areaId: rowForEdit.areaId,
    updatedBy: "",
    updatedOn: null,
    isActive: rowForEdit.isActive,
  };
  const [addNewData] = useState([defaulValues]);
  const [editData] = useState([defaultEditValues]);
  const [managerEmail, setManagerEmail] = useState(
    actionEditState
      ? defaultEmployee?.length === 0
        ? ""
        : rowForEdit.managerEmail
      : addNewData.managerEmail
  );
  const [managerUltiproNumber, setManagerUltiproNumber] = useState(
    actionEditState
      ? defaultEmployee?.length === 0
        ? ""
        : rowForEdit.managerUltiproNumber
      : addNewData.managerUltiproNumber
  );

  const handleAddRegion = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setRegionExist(false);
    inputvalue =
      fieldName === "areaId" || fieldName === "regionManager"
        ? inputvalue
        : inputvalue.trim();
    if (SourceType === "addRegion") {
      if (fieldName === "salesforceId") {
        addNewData.map((x) => (x.salesforceId = inputvalue));
      }
      if (fieldName === "regionCode") {
        addNewData.map((x) => (x.regionCode = inputvalue));
      }
      if (fieldName === "regionName") {
        addNewData.map((x) => (x.regionName = inputvalue));
      }
      if (fieldName === "regionManager") {
        setManagerEmail(inputvalue === null ? "" : inputvalue.email);
        setManagerUltiproNumber(inputvalue === null ? "" : inputvalue.empNo);
        addNewData.map(
          (x) =>
            (x.regionManager = inputvalue === null ? "" : inputvalue.fullname)
        );
        addNewData.map(
          (x) => (x.managerEmail = inputvalue === null ? "" : inputvalue.email)
        );
        addNewData.map(
          (x) =>
            (x.managerUltiproNumber =
              inputvalue === null ? "" : inputvalue.empNo)
        );
      }
      if (fieldName === "areaId") {
        addNewData.map((x) => (x.areaId = inputvalue));
      }
    }
    if (
      addNewData[0].regionName !== "" &&
      addNewData[0].regionCode !== "" &&
      addNewData[0].areaId !== 0 &&
      !userPermissions.includes(contactPermission)
    ) {
      setHasRegion(true);
    } else if (
      addNewData[0].regionName !== "" &&
      addNewData[0].regionCode !== "" &&
      addNewData[0].areaId !== 0 &&
      addNewData[0].regionManager !== "" &&
      userPermissions.includes(contactPermission)
    ) {
      setHasRegion(true);
    } else {
      setHasRegion(false);
    }
    addNewData.map((x) => (x.createdOn = new Date().toISOString()));
    addNewData.map((x) => (x.createdBy = userAccount.username));
    addNewData.map((x) => (x.isActive = true));
  };

  //save changes
  const handleSaveAdd = (addNewData) => {
    if (changed) {
      if (!regionExist) {
        if (addNewData.filter((x) => x.regionName) !== "") {
          //call Insert
          AddRegion(addNewData);
          if (buttonLinkState) {
            setTimeout(() => {
              handleLink();
            }, 3000);
          }
          setOpenModal(false);
        } else {
          toast.fire("Failed", "Please populate fields!", "error");
          setOpenModal(false);
        }
      } else {
        toast.fire("Failed", "The data already exists!", "error");
        setOpenModal(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setOpenModal(false);
    }
  };
  // end of saving changes

  const handleCheckBox = (checked) => {
    if (
      editData[0].regionName !== "" &&
      editData[0].regionCode !== "" &&
      editData[0].regionManager !== "" &&
      editData[0].areaId !== 0
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
    checked ? setCheckStatus(true) : setCheckStatus(false);
    checked
      ? editData.map((x) => (x.isActive = true))
      : editData.map((x) => (x.isActive = false));
    editData.map((x) => (x.updatedOn = new Date().toISOString()));
    editData.map((x) => (x.updatedBy = userAccount.username));
  };

  const handleEditFieldsChange = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setRegionExist(false);
    inputvalue =
      fieldName === "areaId" || fieldName === "regionManager"
        ? inputvalue
        : inputvalue.trim();
    if (SourceType === "editRegion") {
      if (fieldName === "salesforceId") {
        editData.map((x) => (x.salesforceId = inputvalue));
      }
      if (fieldName === "regionCode") {
        editData.map((x) => (x.regionCode = inputvalue));
      }
      if (fieldName === "regionName") {
        editData.map((x) => (x.regionName = inputvalue));
      }
      if (fieldName === "regionManager") {
        setManagerEmail(inputvalue === null ? "" : inputvalue.email);
        setManagerUltiproNumber(inputvalue === null ? "" : inputvalue.empNo);
        editData.map(
          (x) =>
            (x.regionManager = inputvalue === null ? "" : inputvalue.fullname)
        );
        editData.map(
          (x) => (x.managerEmail = inputvalue === null ? "" : inputvalue.email)
        );
        editData.map(
          (x) =>
            (x.managerUltiproNumber =
              inputvalue === null ? "" : inputvalue.empNo)
        );
      }
      if (fieldName === "areaId") {
        editData.map((x) => (x.areaId = inputvalue));
      }
    }
    if (
      editData[0].regionName !== "" &&
      editData[0].regionCode !== "" &&
      editData[0].regionManager !== "" &&
      editData[0].areaId !== 0
    ) {
      setChanged(true);
    } else {
      setChanged(false);
    }
    editData.map((x) => (x.updatedOn = new Date().toISOString()));
    editData.map((x) => (x.updatedBy = userAccount.username));
  };

  //Save changes
  const handleSaveEdit = (editData) => {
    if (changed) {
      if (!regionExist) {
        if (editData.filter((x) => x.regionName) !== "") {
          UpdateRegion(editData);
          setOpenModalEdit(false);
          if (!actionEditState) {
            setEditRowId([]);
            setSelectedRows([]);
            setEmpTypeIsExistState(false);
            setChanged(false);
            setDisabledButton(false);
          }
        } else {
          toast.fire("Failed", "All fields must be filled!", "error");
          setOpenModalEdit(false);
        }
      } else {
        toast.fire("Failed", "Region already exists!", "error");
        setOpenModalEdit(false);
      }
    } else {
      toast.fire("Saving Failed", "No Changes have been made", "warning");
      setEditRowId([]);
      setOpenModalEdit(false);
      setChanged(false);
      setActionEditState(false);
      setDisabledButton(false);
    }
  };
  // end of saving changes

  const handleLink = () => {
    history.push({
      pathname: "/carrieragreementmgmt/officehierarchy",
      state: {
        recordId: buttonTextLinkState !== "Add" ? hierarcyId + " " : " ",
        moduleName: "Office Hierarchy",
        subModuleName: buttonTextLinkState,
        selectedType: type,
        description: description,
      },
    });
    window.location.reload();
  };
  return (
    <div>
      {areaOptions && defaultEmployee && employeeOptions ? (
        <div className="w-full">
          <div className="p-3 py-2 space-y-1 border-l-6  rounded-l-xl rounder-r-none box-shadow mt-2 ">
            <div className="flex w-full ">
              <div className="text-base text-primary font-bold w-full">
                {actionAddState ? "Add New Region" : "Edit: "}
                {actionAddState ? (
                  ""
                ) : (
                  <div className="italic">{rowForEdit.regionName}</div>
                )}
              </div>
              <div className="flex items-center justify-end space-x-2 w-full">
                <Button
                  className={`flex items-right shadow-md text-xs font-semibold text-white justify-right gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${
                actionAddState
                  ? !hasRegion
                  : !changed
                  ? "opacity-50"
                  : "opactiy-100"
              }`}
                  disabled={actionAddState ? !hasRegion : !changed}
                  onClickFunction={() =>
                    actionAddState ? setOpenModal(true) : setOpenModalEdit(true)
                  }
                >
                  <CheckCircleIcon className="h-4 w-4" />
                  <div className=" self-center -mt-px">Save</div>
                </Button>
                <Button
                  className="flex items-right text-xs shadow-md font-semibold text-white justify-right gap-x-1 rounded-full bg-octonary bg-transparent hover:bg-octonary px-2 py-1 "
                  onClickFunction={() => {
                    if (buttonLinkState) {
                      handleLink();
                    } else {
                      setActionAddState(false);
                      setActionEditState(false);
                      setDisabledButton(false);
                      setFilterText("");
                      setHierarchyType({ Type: "", HierarchyType: "" });
                    }
                  }}
                >
                  <XCircleIcon className="h-4 w-4" />
                  <div className=" self-center -mt-px">Cancel</div>
                </Button>
              </div>
            </div>
            <div className="mt-2 h-1 w-full border-b-4 border-secondary "></div>
            <div className="italic text-secondary text-xs3">
              <b> Note: </b> All fields with * are required to fill
            </div>
            <div className="w-full -mx-2">
              {/* firstrow */}
              <div className="text-xs font-medium ">
                <div className="grid  grid-cols-2 w-full  gap-5 m-2 ">
                  <div className="grid grid-cols-3">
                    <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                      Region Name: <span className="text-red-500">*</span>
                    </label>
                    <div className="">
                      <TextInput
                        defaultValue={
                          actionEditState
                            ? rowForEdit.regionName
                            : addNewData.regionName
                        }
                        onChange={(e) =>
                          !actionEditState
                            ? handleAddRegion(
                                "addRegion",
                                "regionName",
                                e.target.value
                              )
                            : handleEditFieldsChange(
                                "editRegion",
                                "regionName",
                                e.target.value
                              )
                        }
                      />
                    </div>
                  </div>
                  {userPermissions.includes(contactPermission) ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                        Region Manager: <span className="text-red-500">*</span>
                      </label>
                      <div className="">
                        <SelectInput
                          defaultValue={
                            actionEditState
                              ? defaultEmployee
                              : addNewData.regionManager
                          }
                          options={employeeOptions ? employeeOptions : []}
                          onChange={(e) =>
                            !actionEditState
                              ? handleAddRegion(
                                  "addRegion",
                                  "regionManager",
                                  e === null ? null : e
                                )
                              : handleEditFieldsChange(
                                  "editRegion",
                                  "regionManager",
                                  e === null ? null : e
                                )
                          }
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* 2ndrow */}
                <div className="grid  grid-cols-2 w-full  gap-5  m-2">
                  <div className="grid grid-cols-3">
                    <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                      Region Code: <span className="text-red-500">*</span>
                    </label>
                    <div className="">
                      <TextInput
                        defaultValue={
                          actionEditState
                            ? rowForEdit.regionCode
                            : addNewData.regionCode
                        }
                        onChange={(e) =>
                          !actionEditState
                            ? handleAddRegion(
                                "addRegion",
                                "regionCode",
                                e.target.value
                              )
                            : handleEditFieldsChange(
                                "editRegion",
                                "regionCode",
                                e.target.value
                              )
                        }
                      />
                    </div>
                  </div>
                  {userPermissions.includes(contactPermission) ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                        Manager Email:
                      </label>
                      <div className="opacity-50">
                        <TextInput
                          value={managerEmail}
                          disabled={true}
                          type="email"
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* 3rdrow */}
                <div className="grid  grid-cols-2 w-full  gap-5 m-2">
                  <div className="grid grid-cols-3">
                    <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                      Area: <span className="text-red-500">*</span>
                    </label>
                    <div className="">
                      <SelectInput
                        defaultValue={
                          actionEditState ? defaultArea : addNewData.areaId
                        }
                        options={areaOptions ? areaOptions : []}
                        onChange={(e) =>
                          !actionEditState
                            ? handleAddRegion(
                                "addRegion",
                                "areaId",
                                e === null ? 0 : e.value.toString()
                              )
                            : handleEditFieldsChange(
                                "editRegion",
                                "areaId",
                                e === null ? 0 : e.value.toString()
                              )
                        }
                      />
                    </div>
                    {/* <div>
                      <DefaultButton
                        onClick={() => {
                          setOpenAreaModal(true);
                        }}
                        className="flex border-l border-t border-b rounded-md rounded-r-none text-sm flex bg-white order px-2 border-primary bg-primary text-white rounded-md rounded-l-none focus:ring-2 focus:ring-primary focus:ring-offset-1"
                      >
                        Add Area
                      </DefaultButton>
                    </div> */}
                  </div>
                  {userPermissions.includes(contactPermission) ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700 my-1 text-right mr-2">
                        Manager Ultipro Number:
                      </label>
                      <div className="opacity-50">
                        <TextInput
                          value={managerUltiproNumber}
                          disabled={true}
                        />
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {/* 4throw */}
                <div className="grid  grid-cols-2 w-full  gap-5 m-2">
                  {!actionAddState ? (
                    <div className="grid grid-cols-3">
                      <label className="block font-medium text-gray-700  text-right mr-2">
                        Active:
                      </label>
                      <div className="flex justify-left space-x-1 cursor-pointer">
                        <input
                          type="checkbox"
                          className="flex items-left space-x-1 cursor-pointer"
                          defaultChecked={rowForEdit.isActive}
                          onClick={(e) => {
                            handleCheckBox(e.target.checked);
                          }}
                        />
                        <label
                          className="cursor-pointer text-green-600 text-xs"
                          name="Status"
                        >
                          {checkStatus
                            ? "Uncheck to Deactivate"
                            : "Check to Activate"}
                        </label>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                <div className="grid  grid-cols-3  gap-5 m-2"></div>
              </div>
            </div>
          </div>
          <ConfirmBoxModal
            ModalTitle="Add Region"
            qConfirmation=" Are you sure you want to add this?"
            isOpen={openModal}
            onClose={() => setOpenModal(false)}
            onClickFunction={() => {
              handleSaveAdd(addNewData);
            }}
          />
          <ConfirmBoxModal
            ModalTitle="Update Region"
            qConfirmation=" Are you sure you want to update this?"
            isOpen={openModalEdit}
            onClose={() => setOpenModalEdit(false)}
            onClickFunction={() => {
              handleSaveEdit(editData);
            }}
          />

          <div className="hidden sm:block" aria-hidden="true">
            <div className="py-2"></div>
          </div>
        </div>
      ) : (
        <div className="h-96">
          <CustomLoader />
        </div>
      )}
    </div>
  );
};

export default RegionForm;
